import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Typography } from '@mui/material';
import { useMemo } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useLocation } from 'react-router-dom';

import Notificacao from '../../components/notification';
import { ContainedButton } from '../../components/V2/button';

const QrcodePage = () => {
  const location = useLocation();

  const code = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('code') ?? Array.from(params.values())[0] ?? '';
  }, [location.search]);

  const mensagem = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('mensagem') ?? '';
  }, [location.search]);

  return (
    <Box
      sx={{
        marginTop: 8,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
          width: '100%',
          maxWidth: '500px',
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
            whiteSpace: 'pre-wrap',
            fontSize: '1.5rem',
            fontWeight: 'bold',
          }}
        >
          {mensagem}
        </Typography>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            padding: '10px 12px',
            marginBottom: 2,
          }}
        >
          <Typography
            sx={{
              overflowWrap: 'anywhere',
            }}
          >
            {code}
          </Typography>
          <CopyToClipboard
            text={code}
            onCopy={() => {
              Notificacao(
                'Sucesso!',
                `Código copiado para área de transferência!`,
                'success'
              );
            }}
          >
            <IconButton aria-label="Copiar código" size="small">
              <ContentCopyIcon />
            </IconButton>
          </CopyToClipboard>
        </Box>

        <ContainedButton 
            content="Abrir o aplicativo" 
            href="https://onelink.to/6qh3rv"
          target="_blank"
        ></ContainedButton>
      </Box>
    </Box>
  );
};

export default QrcodePage;